import React from 'react';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

// Components
import { WpPageLayout, WpPageHeader, WpPageBody } from 'Wpds/components/page-layout';
import { WpButton } from 'Wpds/components/button';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Styles
import './RootErrorPage.scss';

const RootErrorPage = () => {
  const { tr } = useTranslation();

  const handleBackHomeClick = () => {
    window.location.href = PageUrls.HOME_PAGE;
  };

  const baseClassName = 'RootErrorPage';
  return (
    <WpPageLayout className={baseClassName}>
      <WpPageHeader>
        <WpIllustration
          className={`${baseClassName}__logo`}
          src={Illustrations.pi_logo_full_red_with_text}
          alt="The Predictive Index logo"
        />
      </WpPageHeader>
      <WpPageBody>
        <div className={`${baseClassName}__body`}>
          <WpIllustration
            className={`${baseClassName}__body__img`}
            src={Illustrations.person_working_from_bench_white_bg}
            alt={tr('perform.error_page.title')}
          />
          <h3 className={`${baseClassName}__body__title`}>{tr('perform.error_page.title')}</h3>
          <p className={`${baseClassName}__body__text`}>{tr('perform.error_page.description')} </p>
          <p className={`${baseClassName}__body__text`}>
            {tr('perform.error_page.contact_prefix')}{' '}
            <a href={ExternalLinksConstants.contact_us} target="_blank" rel="noopener noreferrer">
              {tr('perform.error_page.contact_link')}
            </a>{' '}
            {tr('perform.error_page.contact_suffix')}
          </p>
          <WpButton size="lg" onClick={handleBackHomeClick}>
            {tr('perform.error_page.back_home_button')}
          </WpButton>
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default RootErrorPage;
